export default __webpack_public_path__ + "static/media/Conscript's Boots of the Watchtowers.fa590c49.jpg";